var React = require('react');

function Deliver (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48.3333 19.3334H41.0833V14.5001C41.0833 11.8417 38.9083 9.66675 36.25 9.66675H21.75C19.0916 9.66675 16.9166 11.8417 16.9166 14.5001V19.3334H9.66665C7.00831 19.3334 4.83331 21.5084 4.83331 24.1667V48.3334H53.1666V24.1667C53.1666 21.5084 50.9916 19.3334 48.3333 19.3334ZM21.75 14.5001H36.25V19.3334H21.75V14.5001ZM48.3333 43.5001H9.66665V36.2501H14.5V38.6667H19.3333V36.2501H38.6666V38.6667H43.5V36.2501H48.3333V43.5001ZM43.5 31.4167V29.0001H38.6666V31.4167H19.3333V29.0001H14.5V31.4167H9.66665V24.1667H16.9166H41.0833H48.3333V31.4167H43.5Z"}));
}

Deliver.defaultProps = {"width":"58","height":"58","viewBox":"0 0 58 58","fill":"none"};

module.exports = Deliver;

Deliver.default = Deliver;
